// src/components/tip_bon_iesire/TipBonIesireList.jsx
import React, { useEffect, useState, useCallback } from "react";
import ReactPaginate from "react-paginate";
import api from "../../axiosConfig";
import {
  Table,
  Button,
  InputGroup,
  FormControl,
  Container,
  Col,
} from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";

import "../pagination.css";

function TipBonIesireList() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get("q") || "";
  const [accMap, setAccMap] = useState({}); // { [id]: "5121 • ..." }

  const fetchItems = useCallback(async () => {
    try {
      const skip = currentPage * itemsPerPage;
      const res = await api.get("/tip_bon_iesire", {
        params: {
          skip,
          limit: itemsPerPage,
          q: search || undefined,
          search: search || undefined,
        },
      });

      // acceptă format {items,total} sau listă simplă
      const data = res.data;
      const rows = Array.isArray(data) ? data : (data.items ?? []);
      const total = Array.isArray(data) ? data.length : (data.total ?? 0);

      setItems(rows);
      setTotalCount(total);
    } catch (err) {
      console.error("Eroare la încărcare:", err);
    }
  }, [search, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const handleSearchChange = (e) => {
    setSearchParams({ q: e.target.value });
    setCurrentPage(0);
  };

  const handleDelete = async (id) => {
    if (
      window.confirm("Sigur dorești să ștergi înregistrarea cu ID " + id + "?")
    ) {
      try {
        await api.delete(`/tip-bon-iesire/${id}`);
        fetchItems();
      } catch (err) {
        alert("Eroare la ștergere.");
      }
    }
  };
  const fetchAccountsMap = useCallback(async () => {
    try {
      const res = await api.get("/accounts", {
        params: { skip: 0, limit: 10000, sort_by: "code", sort_order: "asc" },
      });
      const data = res.data;
      const rows = Array.isArray(data) ? data : (data.items ?? []);

      const m = {};
      for (const a of rows) {
        const code = a.code ?? a.cod ?? "";
        const name = a.name ?? a.denumire ?? "";
        m[a.id] = code ? `${code} • ${name}` : `${a.id} • ${name}`;
      }
      setAccMap(m);
    } catch (e) {
      console.error("Eroare la încărcare conturi:", e);
      setAccMap({});
    }
  }, []);

  useEffect(() => {
    fetchAccountsMap();
  }, [fetchAccountsMap]);

  const pageCount = Math.max(1, Math.ceil((totalCount || 0) / itemsPerPage));
  const accLabel = (id) => (id ? accMap[id] || `#${id}` : "");
  return (
    <Container className="mt-4">
      <h2>Lista TipBonIesire</h2>

      <Col className="text-end">
        <Button
          className="mb-3"
          onClick={() => navigate("/tip-bon-iesire/create")}
        >
          Adaugă
        </Button>
      </Col>

      <InputGroup className="mb-3">
        <FormControl
          placeholder="Caută după denumire"
          value={search}
          onChange={handleSearchChange}
        />
        {search && (
          <Button
            variant="outline-danger"
            onClick={() => {
              setSearchParams({});
              setCurrentPage(0);
            }}
          >
            Curăță
          </Button>
        )}
      </InputGroup>

      <div className="mb-3">
        <label>
          Rânduri pe pagină:&nbsp;
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(parseInt(e.target.value));
              setCurrentPage(0);
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
        </label>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>denumire</th>
            <th>contd_id (debit)</th>
            <th>contc_id (credit default)</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => (
            <tr key={it.id}>
              <td>{it.id}</td>
              <td>{it.denumire}</td>
              <td>
                <span style={{ fontFamily: "monospace" }}>
                  {accLabel(it.contd_id)}
                </span>
              </td>
              <td>
                <span style={{ fontFamily: "monospace" }}>
                  {accLabel(it.contc_id)}
                </span>
              </td>
              <td>
                <Button
                  size="sm"
                  onClick={() => navigate(`/tip-bon-iesire/${it.id}`)}
                >
                  Editează
                </Button>{" "}
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(it.id)}
                >
                  Șterge
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <ReactPaginate
        previousLabel={"← Înapoi"}
        nextLabel={"Înainte →"}
        pageCount={pageCount}
        forcePage={currentPage}
        onPageChange={(event) => setCurrentPage(event.selected)}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </Container>
  );
}

export default TipBonIesireList;
